import React from 'react'
import PropTypes from 'prop-types'
import { useSpring, animated } from 'react-spring'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  container: ({ backgroundImage }) => ({
    backgroundColor: 'var(--theme-color-surface-d0)',
    margin: 'inherit',
    position: 'absolute',
    width: '100%',
    height: '100%',
    minHeight: '100%',
    overflowY: 'hidden',
    top: 0,
    backgroundImage: `url(${backgroundImage})` || 'url("RiverBack_50.png")',
    backgroundPosition: 'bottom center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  }),
  content: {
    position: 'relative',
    height: '100%',
    width: '100%',
    overflowY: 'auto',
    minHeight: '100%'
  },
  [theme.breakpoints.down('xs')]: {
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      minHeight: '100%',
      height: 'auto',
      margin: '1rem 0',
      padding: '0 1rem'
    }
  }
}))

const AbundanceEngineGalleryContainer = ({
  backgroundImage,
  children,
  className,
  header,
  footer,
  contentClassName
}) => {
  const classes = useStyles({ backgroundImage })
  const springs = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 }
  })

  const containerClassNames = clsx(classes.container, {
    [className]: Boolean(className)
  })
  const contentClassNames = clsx(classes.content, {
    [contentClassName]: Boolean(contentClassName)
  })

  return (
    <animated.div className={containerClassNames} style={{ ...springs }}>
      {header}
      <div className={contentClassNames}>{children}</div>
      {footer}
    </animated.div>
  )
}

AbundanceEngineGalleryContainer.propTypes = {
  backgroundImage: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  header: PropTypes.node,
  footer: PropTypes.node
}

export default AbundanceEngineGalleryContainer
